import React, { useEffect, useState } from 'react'
import PageBodyWrapper from '../../components/PageBodyWrapper'
import { Paginator, SearchAndFilterToolbar, StatusBar } from '../../components/common'
import { useSearchParams } from 'react-router-dom';
import StocksTable from '../../components/stocks/StocksTable';
import { parseSearchParams } from '../../components/common/filterableForm';
import useApi from '../../api';
import StockForm from '../../components/stocks/StockForm';
import StockFilter from '../../components/stocks/StockFilter';
import { handleRetriveError } from '../../utils';

function Stocks() {
  const [stocks, setStocks] = useState<any>()
  const [isOpenStockCreateForm, setIsOpenStockCreateForm] = useState<boolean>(false)
  const [isOpenStockFilter, setISOpenStockFilter] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const currentStatus = searchParams.get("status");
  const api = useApi()
  
  const [filterData, setFilterData] =  useState<any>({});

  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("status", status);
    newParams.set("page", "1"); 
    setSearchParams(newParams);
  };

  const toggleStockCreateForm = () => {
    setIsOpenStockCreateForm(!isOpenStockCreateForm)
  }


  const fetchStocks = () => {
    const queryObject = parseSearchParams(searchParams);
    api.getStocks(queryObject).then(
      (response: any) => {
        setStocks(response);
      }, handleRetriveError);
  };

  useEffect(()=>{
    fetchStocks()
  }, [searchParams])


  return (
    <PageBodyWrapper>
      <StatusBar
        statusList={[]}
        currentStatus={currentStatus}
        onChangeStatus={changeStatus}
        buttonLabel='Add Stock'
        onButtonClick={toggleStockCreateForm}
      />
      
      <SearchAndFilterToolbar
        onFilterOpen={() => setISOpenStockFilter(!isOpenStockFilter)}
        onRefresh={fetchStocks}
        onClearFilters={() => setFilterData({})}
        startDateKey={"created_at_after"}
        endDateKey={"created_at_before"}
      />

      {isOpenStockFilter && <StockFilter isOpen={isOpenStockFilter} onClose={()=>setIsOpenStockCreateForm(!isOpenStockFilter)}/>}

      <StocksTable data={stocks?.results || []} refresh={fetchStocks}/>

      <Paginator data={stocks}/>

      <StockForm isOpen={isOpenStockCreateForm} onClose={toggleStockCreateForm} refresh={fetchStocks}/>


      
    </PageBodyWrapper>
  )
}

export default Stocks